import React from "react";
import styles from "./BlackFridayEdge.module.scss";

export default function BlackFridayEdge() {
  return (
    <div className={`col-12 g-0 d-flex justify-content-center px-3 ${styles.container}`}>
      <img src="/img/Edge-BF-banner-full2.webp" alt="black friday banner" />
    </div>
  );
}
